declare var $

export class Video {

  el: HTMLElement
  videoEl: HTMLVideoElement

  constructor(el) {
		this.el = el
    this.videoEl = $('video', this.el).get(0)
		this.init()
	}

  init() {
    console.log( 'init video' )
    this.showPaused(true)
    $(this.videoEl)
      .on('click', (e) => {
        e.preventDefault()
        this.togglePlayback()
      })
  }

  togglePlayback() {
    if ( this.videoEl.readyState < 4 ) return
    if ( this.videoEl.paused ) {
      this.play()
    } else {
      this.pause()
    }
  }

  play() {
    this.videoEl.play()
    this.showPaused(false)
  }

  pause() {
    this.videoEl.pause()
    this.showPaused(true)
  }

  showPaused( paused: boolean) {
    $(this.el).toggleClass('paused', paused)
  }

}